import { render, staticRenderFns } from "./identifyResult.vue?vue&type=template&id=4d4ff4b8&scoped=true"
import script from "./identifyResult.vue?vue&type=script&lang=js"
export * from "./identifyResult.vue?vue&type=script&lang=js"
import style0 from "./identifyResult.vue?vue&type=style&index=0&id=4d4ff4b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ff4b8",
  null
  
)

export default component.exports